module.exports = __webpack_public_path__ + "img/JC_bie.731af1b9.png";